import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { Map, MapPin, Factory, Network, UserRound, Truck, Search, ChevronLeft, ChevronRight } from 'lucide-react'
import s from './PanelBase.module.scss'
import { SectionHeading, EmptyState } from 'components/Erp/Presentation'
import ReadOnlyOperatorsList from './ReadOnlyOperatorsList'
import ReadOnlyDriversList from './ReadOnlyDriversList'
import ReadOnlyBranchesList from './ReadOnlyBranchesList'
import MiniMap from 'pages/ReportCard/MiniMap'

const ChppsPanel = ({
  chppsFilter,
  setChppsFilter,
  filteredChpps,
  chppsPagination,
  loadChppsPage,
  expandedChpp,
  setExpandedChpp,
  expandedOperatorsChpp,
  setExpandedOperatorsChpp,
  expandedDriversChpp,
  setExpandedDriversChpp,
  expandedBranchesChpp,
  setExpandedBranchesChpp,
  loadOperatorsByChppPage,
  loadDriversByChppPage,
  loadBranchesByChppPage,
  operatorsByChpp,
  driversByChpp,
  branchesByChpp,
  operatorsPaginationByChpp,
  driversPaginationByChpp,
  branchesPaginationByChpp,
  operatorsFilterByChpp,
  driversFilterByChpp,
  branchesFilterByChpp,
  setOperatorsFilterByChpp,
  setDriversFilterByChpp,
  setBranchesFilterByChpp,

  expandedDriverByChpp,
  toggleDriver,
  chpps
}) => {
  useInterfaceLanguage();
  return (
    <div className={s.panel}>
      <div className={s.header}>
        <SectionHeading icon={Factory} title={tr("ТЭЦ")} />
        {tr(chppsPagination?.count > 0 && (
          <span className={s.totalBadge}>{tr("Всего: ")}{tr(chppsPagination.count)}</span>
        ))}
      </div>

      <div className={s.searchRow}>
        <Search size={16} aria-hidden="true" />
        <input className={s.searchInput} placeholder={tr("Поиск по ТЭЦ...")} value={chppsFilter} onChange={(e) => setChppsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadChppsPage(1, chppsFilter) }} />
      </div>

      {filteredChpps && filteredChpps.length ? (
        <div className={s.tableWrap}>
          <div className={s.tableScroll}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Название")}</th>
                <th>{tr("Телефон")}</th>
                <th>{tr("Местоположение")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredChpps.map((chpp, index) => (
                <React.Fragment key={chpp.id}>
                  <tr>
                    <td data-label={tr("№")} className={s.numCell}>{tr(index + 1)}</td>
                    <td data-label={tr("Название")} className={s.nameCell} onClick={() => { const newVal = (expandedChpp === chpp.id ? null : chpp.id); setExpandedChpp(newVal); if (newVal) loadOperatorsByChppPage(chpp.id, 1); }}>{tr(chpp.name)}</td>
                    <td data-label={tr("Телефон")}>{tr(chpp.phone || '—')}</td>
                    <td data-label={tr("Местоположение")}>
                      {chpp.geo ? (
                        <div style={{ display: 'flex', gap: '6px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${chpp.geo}`, '_blank')} className={s.geoBtn}><Map size={14} aria-hidden="true" />{tr(" Карты")}</button>
                            <button onClick={() => { const el = document.getElementById(`chpp-map-${chpp.id}`); if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none'; }} className={s.mapToggleBtn} aria-label={tr("Показать или скрыть мини-карту")}><MapPin size={15} aria-hidden="true" /></button>
                          </div>
                          <div id={`chpp-map-${chpp.id}`} style={{ width: 200, height: 150, display: 'none' }}><MiniMap geo={chpp.geo} /></div>
                        </div>
                      ) : '—'}
                    </td>
                    <td data-label={tr("Действия")}>
                      <button className={`${s.actionBtn}${expandedBranchesChpp === chpp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedBranchesChpp === chpp.id ? null : chpp.id; setExpandedBranchesChpp(v); if (v) loadBranchesByChppPage(chpp.id, 1); setExpandedChpp(chpp.id); }}><Network size={14} aria-hidden="true" />{tr("Филиалы")}</button>
                      <button className={`${s.actionBtn}${expandedOperatorsChpp === chpp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedOperatorsChpp === chpp.id ? null : chpp.id; setExpandedOperatorsChpp(v); if (v) loadOperatorsByChppPage(chpp.id, 1); setExpandedChpp(chpp.id); }}><UserRound size={14} aria-hidden="true" />{tr("Операторы")}</button>
                      <button className={`${s.actionBtn}${expandedDriversChpp === chpp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedDriversChpp === chpp.id ? null : chpp.id; setExpandedDriversChpp(v); if (v) loadDriversByChppPage(chpp.id, 1); setExpandedChpp(chpp.id); }}><Truck size={14} aria-hidden="true" />{tr("Водители")}</button>
                    </td>
                  </tr>
                  {tr(expandedChpp === chpp.id && (
                    <tr className={s.subRow}>
                      <td colSpan={5}>
                        <div className={s.subContent}>
                          {tr(expandedOperatorsChpp === chpp.id && (
                            <ReadOnlyOperatorsList
                              base={chpp}
                              operators={operatorsByChpp[chpp.id]}
                              operatorsFilter={operatorsFilterByChpp[chpp.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByChpp(prev => ({ ...prev, [chpp.id]: v }))}
                              loadOperatorsPage={loadOperatorsByChppPage}
                              operatorsPagination={operatorsPaginationByChpp[chpp.id]}
                              title={tr("Операторы этой ТЭЦ")}
                            />
                          ))}

                          {tr(expandedDriversChpp === chpp.id && (
                            <ReadOnlyDriversList
                              base={chpp}
                              drivers={driversByChpp[chpp.id]}
                              driversFilter={driversFilterByChpp[chpp.id]}
                              setDriversFilter={(v) => setDriversFilterByChpp(prev => ({ ...prev, [chpp.id]: v }))}
                              loadDriversPage={loadDriversByChppPage}
                              driversPagination={driversPaginationByChpp[chpp.id]}
                              expandedDriver={expandedDriverByChpp}
                              toggleDriver={toggleDriver}
                              title={tr("Водители этой ТЭЦ")}
                            />
                          ))}

                          {tr(expandedBranchesChpp === chpp.id && (
                            <ReadOnlyBranchesList
                              base={chpp}
                              baseType="ТЭЦ"
                              branches={branchesByChpp[chpp.id]}
                              branchesFilter={branchesFilterByChpp[chpp.id]}
                              setBranchesFilter={(v) => setBranchesFilterByChpp(prev => ({ ...prev, [chpp.id]: v }))}
                              loadBranchesPage={loadBranchesByChppPage}
                              branchesPagination={branchesPaginationByChpp[chpp.id]}
                            />
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ) : (
        <EmptyState icon={Factory} title={tr("Список пуст")} description={tr("Измените поиск или проверьте записи в этом разделе.")} compact />
      )}

      {tr(!chppsFilter && chppsPagination?.count > 0 && (
        <div className={s.pagination}>
          <button className={s.pageBtn} disabled={!chppsPagination.previous} onClick={() => loadChppsPage((chppsPagination.page || 1) - 1)}><ChevronLeft size={15} aria-hidden="true" />{tr("Пред.")}</button>
          <span>{tr("Стр. ")}{tr(chppsPagination.page || 1)}{tr(" из ")}{Math.ceil(chppsPagination.count / 25)}</span>
          <button className={s.pageBtn} disabled={!chppsPagination.next} onClick={() => loadChppsPage((chppsPagination.page || 1) + 1)}>{tr("След.")}<ChevronRight size={15} aria-hidden="true" /></button>
        </div>
      ))}
    </div>
  )
}

export default ChppsPanel
